import eventSettings from '../../../events.config.json'

const DEFAULT_TRACKUX_ENDPOINT = 'https://trackux-ingestion.frank-bonnet.workers.dev'

function getTrackerEnabled(trackerName) {
  return eventSettings?.trackers?.[trackerName]?.enabled === true
}

export function getEventRuntimeConfig() {
  return Object.freeze({
    trackers: {
      googleAnalytics: Object.freeze({
        enabled: getTrackerEnabled('googleAnalytics'),
        measurementId: process.env.GATSBY_GA_MEASUREMENT_ID ?? '',
      }),
      log: Object.freeze({
        enabled: getTrackerEnabled('log'),
      }),
      trackUx: Object.freeze({
        enabled: getTrackerEnabled('trackUx'),
        projectId: process.env.GATSBY_TRACKUX_PROJECT_ID ?? '',
        publicKey: process.env.GATSBY_TRACKUX_PUBLIC_KEY ?? '',
        endpoint: process.env.GATSBY_TRACKUX_ENDPOINT ?? DEFAULT_TRACKUX_ENDPOINT,
        environment: process.env.GATSBY_TRACKUX_ENVIRONMENT ?? 'development',
        debug: process.env.NODE_ENV !== 'production',
      }),
    },
  })
}
